import { 
    SHOW_CHANGE_PASS_MODAL, 
    CLOSE_CHANGE_PASS_MODAL,
    LOADER_STATUS,
    RESPONSE_MESSAGE,
 } from './constants';

const initialState = {
    showPasswordModal : false,
    loaderStatus: false,
    msg: "",
    status: false,
    error: 0,
}
const passwordChangeReducer = (state = initialState, action) => {
    switch (action.type) {
      case SHOW_CHANGE_PASS_MODAL:
        return {
          ...state,
          showPasswordModal: true,
        };
        case CLOSE_CHANGE_PASS_MODAL:
        return {
          ...state,
          showPasswordModal: false,
        };
        case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        };
        case RESPONSE_MESSAGE:
        return {
            ...state,
            msg:action.msg,
            status:action.status,
            error:action.error
        }
        default:
            return state;
    }
}

export default passwordChangeReducer;